import { useTranslation } from 'react-i18next';
// frontend/src/components/common/ImageUpload.jsx - CORREGIDO
import React, { useState } from 'react';
import {
    Box,
    Button,
    IconButton,
    Card,
    CardMedia,
    Chip,
    CircularProgress,
    Grid,
    Alert
} from '@mui/material';
import {
    CloudUpload as UploadIcon,
    Delete as DeleteIcon,
    Star as StarIcon
} from '@mui/icons-material';
import axios from 'axios';

const ImageUpload = ({ images = [], mainImage = '', onChange, maxImages = 10 }) => {
  const { t } = useTranslation();
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);

    const handleFileSelect = async (event) => {
        const files = Array.from(event.target.files);

        if (files.length + images.length > maxImages) {
            setError(t('hardcoded.components_common_imageupload.maximo_maximages_imagenes_permitidas', { maxImages: maxImages }));
            return;
        }

        setUploading(true);
        setError(null);

        try {
            const token = localStorage.getItem('authToken') || localStorage.getItem('access_token');
            const uploadedUrls = [];

            for (const file of files) {
                const formData = new FormData();
                formData.append(t('hardcoded.components_common_imageupload.file'), file);

                // ✅ CORREGIDO: Agregar /api/ al path
                const response = await axios.post(
                    '/api/uploads/image',  // ← CAMBIADO
                    formData,
                    {
                        headers: {
                            'Authorization': t('hardcoded.components_common_imageupload.bearer_token', { token: token }),
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (response.data.success) {
                    uploadedUrls.push(response.data.url);
                }
            }

            const newImages = [...images, ...uploadedUrls];
            const newMainImage = mainImage || uploadedUrls[0] || '';

            onChange({
                images: newImages,
                mainImage: newMainImage
            });

        } catch (error) {
            console.error(t('hardcoded.components_common_imageupload.upload_error'), error);
            const errorMsg = error.response?.data?.detail || error.message || t('hardcoded.components_common_imageupload.error_al_subir_imagenes');
            setError(errorMsg);
        } finally {
            setUploading(false);
        }
    };

    const handleRemove = (imageUrl) => {
        const newImages = images.filter(img => img !== imageUrl);
        const newMainImage = mainImage === imageUrl ? (newImages[0] || '') : mainImage;

        onChange({
            images: newImages,
            mainImage: newMainImage
        });
    };

    const handleSetMain = (imageUrl) => {
        onChange({
            images: images,
            mainImage: imageUrl
        });
    };

    return (
        <Box>
            {error && (
                <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <input
                accept="image/*"
                style={{ display: 'none' }}
                id="image-upload-input"
                multiple
                type="file"
                onChange={handleFileSelect}
                disabled={uploading || images.length >= maxImages}
            />

            <label htmlFor="image-upload-input">
                <Button
                    variant="outlined"
                    component="span"
                    startIcon={uploading ? <CircularProgress size={20} /> : <UploadIcon />}
                    disabled={uploading || images.length >= maxImages}
                    sx={{ mb: 2 }}
                >
                    {uploading ? t('hardcoded.components_common_imageupload.subiendo') : t('hardcoded.components_common_imageupload.subir_imagenes')}
                </Button>
            </label>

            {images.length > 0 && (
                <Grid container spacing={2}>
                    {images.map((image, index) => (
                        <Grid item xs={6} sm={4} md={3} key={index}>
                            <Card sx={{ position: 'relative' }}>
                                <CardMedia
                                    component="img"
                                    height="150"
                                    image={image}
                                    alt={`Image ${index + 1}`}
                                    onError={(e) => {
                                        e.target.src = '/images/placeholder-product.jpg';
                                    }}
                                />
                                <Box sx={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.5
                                }}>
                                    <IconButton
                                        size="small"
                                        onClick={() => handleRemove(image)}
                                        sx={{
                                            bgcolor: 'error.main',
                                            color: 'white',
                                            '&:hover': { bgcolor: 'error.dark' }
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                    {mainImage !== image && (
                                        <IconButton
                                            size="small"
                                            onClick={() => handleSetMain(image)}
                                            sx={{
                                                bgcolor: 'primary.main',
                                                color: 'white',
                                                '&:hover': { bgcolor: 'primary.dark' }
                                            }}
                                        >
                                            <StarIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                                {mainImage === image && (
                                    <Chip
                                        label={t('hardcoded.components_common_imageupload.principal')}
                                        color="primary"
                                        size="small"
                                        sx={{ position: 'absolute', bottom: 4, left: 4 }}
                                    />
                                )}
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default ImageUpload;